/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContentBox_postSummary$ref = any;
export type ContentBoxWrapperQueryVariables = {|
  postId?: ?string
|};
export type ContentBoxWrapperQueryResponse = {|
  +postSummary: ?{|
    +$fragmentRefs: ContentBox_postSummary$ref
  |}
|};
export type ContentBoxWrapperQuery = {|
  variables: ContentBoxWrapperQueryVariables,
  response: ContentBoxWrapperQueryResponse,
|};
*/


/*
query ContentBoxWrapperQuery(
  $postId: String
) {
  postSummary(postId: $postId) {
    ...ContentBox_postSummary
    id
  }
}

fragment ContentBox_postSummary on PostSummaryNode {
  summary
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "postId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "postId",
    "variableName": "postId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentBoxWrapperQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PostSummaryNode",
        "kind": "LinkedField",
        "name": "postSummary",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContentBox_postSummary"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentBoxWrapperQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PostSummaryNode",
        "kind": "LinkedField",
        "name": "postSummary",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "summary",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7fc04261e6abc8d11c1beb34c71f357f",
    "id": null,
    "metadata": {},
    "name": "ContentBoxWrapperQuery",
    "operationKind": "query",
    "text": "query ContentBoxWrapperQuery(\n  $postId: String\n) {\n  postSummary(postId: $postId) {\n    ...ContentBox_postSummary\n    id\n  }\n}\n\nfragment ContentBox_postSummary on PostSummaryNode {\n  summary\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'be4f568547959271848ddfada2b99b1f';

module.exports = node;
